import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { isMobile } from 'react-device-detect';

const GenericGuideSpace = (props) => {

    useEffect(() => {

    }, []);

    return (
        <div className='generic-guide-space' style={{ height: (isMobile ? props.iContent.heightForMobile?.value : props.iContent.heightForWeb?.value) + 'px' }}></div>
    );
};

const mapStateToProps = (state) => {
    return {};
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(GenericGuideSpace);